import "./Catering.module.css";
import Header from "@/reusable_sections/Header";
import CompleteProjectKits from "./sections/CompleteProjectKits";
import NosForfaitsPremium from "./sections/NosForfaitsPremium";
import InquiryForm from "./sections/InquiryForm";
import Footer from "@/reusable_sections/Footer";
export default function CateringPage() {
  return <div>
      <Header />
      <CompleteProjectKits />
      <NosForfaitsPremium />
      <InquiryForm />
      <Footer />
    </div>;
}